import { Themed } from "@client/styles/themes";
import React from "react";
import { VisuallyHidden } from "react-aria";

import { AuthorBlock as Value } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { Clickable } from "../Clickables";
import { RichText } from "../RichText";

import styles from "./index.module.scss";

interface SocialLinkProps {
    link: NonNullable<Value["social_links"]>[number];
}

const SocialLink = ({ link }: SocialLinkProps) => {
    if (!link.url) return <></>;

    return (
        <li>
            <Clickable
                href={link.url}
                className={styles.socialLink}
                icon={null}
                target="_blank"
            >
                {link.image ? (
                    <>
                        <div
                            className={
                                link.override_icon_color
                                    ? styles.socialIconOverrideColor
                                    : styles.socialIcon
                            }
                        >
                            <ImageChooserBlock value={link.image} />
                        </div>
                        <VisuallyHidden>{link.name}</VisuallyHidden>
                    </>
                ) : (
                    <span>{link.name}</span>
                )}
            </Clickable>
        </li>
    );
};

interface Props {
    value: Value;
    id?: string;
}

export const AuthorBlock = ({ value, id }: Props) => {
    return (
        <Themed theme="trueWhite" className={styles.root}>
            <div className={styles.content}>
                {value.avatar && (
                    <ImageChooserBlock
                        value={value.avatar}
                        attrs={{ className: styles.picture }}
                        imageAttrs={{ className: styles.avatar, sizes: "80px" }}
                    />
                )}
                <div className={styles.header}>
                    <div className={styles.author}>
                        {value.eyebrow && (
                            <div className={styles.eyebrow}>
                                {value.eyebrow}
                            </div>
                        )}
                        <h3 className={styles.name}>{value.name}</h3>
                    </div>
                    {value.social_links && value.social_links.length > 0 && (
                        <ul className={styles.socialLinks}>
                            {value.social_links.map((link, index) => (
                                <SocialLink
                                    key={`${id}-social-${index}`}
                                    link={link}
                                />
                            ))}
                        </ul>
                    )}
                </div>
            </div>
            {value.description && (
                <RichText
                    value={value.description}
                    className={styles.description}
                />
            )}
        </Themed>
    );
};
